import { Collapse } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import React from 'react';

import {
  SidebarListItem,
  SidebarListItemProps,
} from 'src/legacy/components/Sidebar/SidebarListItem';
import { TooltipWrapper } from 'src/legacy/components/Tooltip';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    collapse: {
      '& .MuiCollapse-wrapper': {
        marginTop: theme.spacing(-1),
        marginBottom: theme.spacing(-1),
      },
    },
  }),
);

interface CollapseItemProps {
  show: boolean;
}

export const CollapseItem: React.FC<
  SidebarListItemProps & CollapseItemProps
> = ({
  htmlId,
  label,
  handleClick,
  IconElement,
  show,
  children,
  selected,
  disabled,
  tooltipTitle,
}) => {
  const classes = useStyles();

  return (
    <TooltipWrapper title={tooltipTitle}>
      <SidebarListItem
        selected={selected && !show}
        htmlId={htmlId}
        label={label}
        handleClick={handleClick}
        IconElement={IconElement}
        disabled={disabled}
      />
      <Collapse
        className={classes.collapse}
        appear={false} // disable animation on first mount
        enter={false} // disable enter animation
        exit={false} // disable exit animation
        in={show}
        timeout="auto"
        unmountOnExit
      >
        {children}
      </Collapse>
    </TooltipWrapper>
  );
};
